import borderColor from "material-ui/svg-icons/editor/border-color";
import colors from "./colors";

export default {
  container: {
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    padding: 20,
    border: "solid 1px",
    borderColor: colors.primary,
    borderRadius: 5,
    marginBottom: 20,
    boxShadow: "1px 3px 1px #9E9E9E",
  },
  header: {
    fontSize: 16,
    color: colors.primary,
  },
  labelContainer: {
    maringBottom: 5,
    justifyContent: "space-between",
    alignContent: "center",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
  },
  mediaBlock: {
    margin: 20,
    justifyContent: "space-evenly",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  labelItem: {
    paddingRight: 20,
  },
  label: {
    marginRight: 5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color: colors.primary,
  },
  borderBottom: {
    borderBottom: "solid",
    borderBottomWidth: 1,
    color: colors.darkGrey,
    marginTop: 30,
    marginBottom: 10,
    padding: 0,
  },
  vidPlayer: {
    flex: 1,
    width: "100%",
    maxHeight: 350,
    minWidth: 300,
    marginRight: 20,
    marginBottom: 20,
  },
  instructionImg: {
    flex: 1,
    width: "100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain, cover",
    minWidth: 300,
    minHeight: 200,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 20,
    marginBottom: 20,
  },
  instructionImgFullScreen: {
    position: "fixed",
    zIndex: "10000",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    backgroundColor: "white",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain, cover",
  },
  closeMsg: {
    position: "fixed",
    bottom: 0,
    right: 50,
    fontSize: 36,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    pointer: "finger",
  },
};



// WEBPACK FOOTER //
// ./src/styles/instructionview.js